import React from 'react';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import MuiListItem, { ListItemProps as MuiListItemProps } from '@material-ui/core/ListItem';
import classnames from 'classnames';

const styles = () =>
  createStyles({
    disablePadding: {
      padding: 0,
    },
    disableHover: {
      '&:hover': {
        backgroundColor: 'initial',
      },
    },
  });

export interface ListItemProps extends Omit<MuiListItemProps, 'classes'>, WithStyles<typeof styles> {
  disablePadding?: boolean;
  disableHover?: boolean;
}

const ListItem: React.FC<ListItemProps> = ({ classes, className, disablePadding, disableHover, ...rest }) => (
  <MuiListItem
    className={classnames(className, {
      [classes.disablePadding]: disablePadding,
      [classes.disableHover]: disableHover,
    })}
    {...rest}
  />
);

export default withStyles(styles)(ListItem);
